<div
  [@gradientTrigger]="gradientState"
  (@gradientTrigger.done)="gradientAnimationDone($event)"
  #container
  class="container"
  [class.overflow-hidden]="overflowHidden"
  [ngStyle]="{ background: background, color: textColor, backgroundSize: backgroundSize }"
  [class.ready]="contentReady"
  [class.hidden-promotion]="shouldHidePromotions"
  [style.--color-light]="background + '4D'"
  [style.--color]="background"
  [style.--color-brighter]="brighterColor"
  [style.--color-darker]="darkerColor"
  [class.no-logo]="brandingInfo && !isPreview ? brandingInfo!.isBranded && !brandingInfo!.logoUrl : false"
  (scroll)="onScroll($event)">
  <ng-container *ngIf="!loadingState && !errorState && brandingInfo && orderDetails && merchantDetails">
    <ng-container *ngIf="!shouldHidePromotions">
      <header [class.ready]="contentReady">
        <div
          class="logo-container"
          *ngIf="contentReady && (!brandingInfo.isBranded || brandingInfo.logoUrl || addLogoPlaceHolder)"
          [class.smaller]="scrolled"
          [class.centered-logo]="centeredLogo">
          <a
            *ngIf="brandingInfo!.logoUrl"
            [href]="brandingInfo!.websiteUrl"
            [class.disabled]="!brandingInfo!.websiteUrl"
            trackable="{{ trackingPrefix || '' }}Tracking Page/{{
              orderDetails!.customerTrackingStatus
            }}/Merchant logo website"
            target="_blank">
            <img class="loader" *ngIf="!logoLoaded" src="assets/loading-circle-white-animated.svg" />
            <img [src]="brandingInfo!.logoUrl" [hidden]="logoLoaded === false" (load)="logoLoaded = true" />
          </a>
          <a
            *ngIf="!brandingInfo!.isBranded && !addLogoPlaceHolder && !hideEvermileLogo"
            href="https://www.evermile.ai"
            target="_blank"
            trackable="{{ trackingPrefix || '' }}Tracking Page/{{
              orderDetails!.customerTrackingStatus
            }}/Evermile logo website">
            <common-evermile-logo [width]="130" [height]="30" [color]="textColor" />
          </a>
          <div *ngIf="isPreview && !brandingInfo!.logoUrl && addLogoPlaceHolder" id="logo-preview-hint">
            Logo will appear here
          </div>
        </div>
      </header>
      <div
        class="shadow-blocker shadow-blocker--header"
        *ngIf="contentReady && (!brandingInfo!.isBranded || brandingInfo!.logoUrl || addLogoPlaceHolder)"></div>
    </ng-container>
    <main>
      <div @pageAnimations *ngIf="contentReady" class="main-sections">
        <section
          class="title-section fade-in"
          [class.display]="displayTitle"
          *ngIf="!brandingInfo!.enableTrackingMap || orderDetails!.isGift">
          <p #title id="title" [class.wrap]="wrapTitle" *ngIf="!orderDetails!.isGift">
            <span
              >{{
                'Hey ' +
                  orderDetails!.pickupCustomerName +
                  ', here is your ' +
                  (orderDetails!.isExternalPickup ? 'home collection by' : 'order from')
              }}
            </span>
            <span class="merchant-name" [class.block]="merchantNameDisplayBlock">
              {{ merchantDetails!.name }}
            </span>
          </p>
          <common-order-tracking-title
            *ngIf="
              (orderDetails!.isGift && !isSenderTracking) ||
              (orderDetails!.delayedInTransit && orderDetails!.isGift && isSenderTracking)
            "
            [customerTrackingStatus]="orderDetails!.customerTrackingStatus"
            [isSenderTracking]="isSenderTracking"
            [senderName]="orderDetails!.senderName"
            [merchantName]="merchantDetails!.name"
            [pickupCustomerName]="orderDetails!.pickupCustomerName"
            [backgroundColor]="background"
            [isDelayed]="!!orderDetails!.delayedInTransit"></common-order-tracking-title>
        </section>
        <section id="order-details" class="order-details-section">
          <div class="order-card fade-in" [class.low-opacity]="isPreview && elementForceScroll">
            <ng-container *ngIf="!mapCardExpanded">
              <ng-template [ngTemplateOutlet]="orderStatusTrackingComp"></ng-template>
            </ng-container>
            <ng-template #orderStatusTrackingComp>
              <common-order-status-tracking
                #orderStatusTracking
                cdkOverlayOrigin
                #trigger="cdkOverlayOrigin"
                [isAdmin]="isAdmin"
                [contained]="contained"
                [showRebookButton]="showRebookOrderButton"
                [disableRebookButton]="disableRebookButton"
                [shouldShowEditButtonForMerchant]="brandingInfo!.enableEditOrderByCustomer || false"
                [fullScreen]="mapCardExpanded"
                (toggleCardFullScreen)="toggleMapCardFullScreen($event)"
                [orderDetails]="orderDetails"
                [mapMarkers]="mapMarkers"
                [externalOrderId]="orderDetails!.externalOrderId"
                [status]="orderDetails!.customerTrackingStatus"
                [dropoffStart]="dropoffStart"
                [communicatedDropoffInfoText]="commitedDropoffInfoText"
                [dropoffEnd]="dropoffEnd"
                [dropoffEta]="dropoffEta"
                [addressLine1]="address?.addressLine1 || ''"
                [addressLine2]="address?.addressLine2"
                [merchantEmail]="brandingInfo!.allowContactEmail ? merchantDetails!.email : undefined"
                [merchantPhone]="brandingInfo!.allowContactPhone ? merchantDetails!.phone : undefined"
                [chatAllowed]="brandingInfo!.chatBranding?.trackingLinksChatBranding?.enabled"
                [merchantName]="
                  brandingInfo!.isBranded || (orderDetails!.isGift && !isSenderTracking)
                    ? undefined
                    : merchantDetails!.name
                "
                [merchantOffset]="merchantDetails!.timezoneOffset || 0"
                [brandColor]="elementsBackground"
                [textColor]="elementsText"
                [allowMapView]="brandingInfo!.enableTrackingMap"
                [shouldShowContactDriverMessage]="orderDetails!.shouldShowContactDriverMessage && !isSenderTracking"
                [nativeTrackingUrl]="orderDetails!.nativeTrackingURL"
                [editCtaFontWeight]="editCtaFontWeight"></common-order-status-tracking>
            </ng-template>
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOpen]="mapCardExpanded"
              [cdkConnectedOverlayHasBackdrop]="true"
              (overlayKeydown)="overlayKeydown($event)"
              (backdropClick)="toggleMapCardFullScreen(false)"
              [cdkConnectedOverlayPanelClass]="'map-overlay-panel'">
              <ng-template [ngTemplateOutlet]="orderStatusTrackingComp"></ng-template>
            </ng-template>
          </div>
          <div
            @fadeInOutTrigger
            *ngIf="
              orderDetails!.isExternalPickup &&
              isSenderTracking &&
              orderDetails!.customerTrackingStatus === StatusEnum.Ordered
            "
            class="fade-in">
            <common-collection-instructions
              [deliveryPartner]="orderDetails!.deliveryCompany"
              [brandColor]="elementsBackground"
              [textColor]="elementsText"
              [labelUrl]="orderDetails!.trackingInfo.labelUrl">
            </common-collection-instructions>
          </div>
          <div
            class="order-card fade-in gift-recipient-message"
            *ngIf="
              orderDetails!.isGift &&
              !isSenderTracking &&
              orderDetails!.customerTrackingStatus === StatusEnum.Delivered &&
              orderDetails!.recipientMessage
            ">
            {{ orderDetails!.recipientMessage }}
          </div>
          <div
            *ngIf="
              address &&
              orderDetails!.customerTrackingStatus !== StatusEnum.Delivered &&
              orderDetails!.customerTrackingStatus !== StatusEnum.Collected &&
              orderDetails!.customerTrackingStatus !== StatusEnum.ReturnedToSender &&
              (!orderDetails!.isGift || isSenderTracking)
            "
            class="order-card fade-in"
            [class.low-opacity]="isPreview && elementForceScroll">
            <common-order-address
              [merchantName]="orderDetails!.merchantName"
              [senderName]="orderDetails!.senderName"
              [dropoffAddressWasEdited]="orderDetails!.editInfo?.editFields?.includes(EditField.DeliveryAddress)"
              [customerInstructions]="orderDetails!.editInfo ? orderDetails!.customerInstructions : null"
              [addressLine1]="address!.addressLine1 || ''"
              [addressLine2]="address!.addressLine2 || ''"
              [brandColor]="elementsBackground"
              [orderStatus]="orderDetails!.customerTrackingStatus"
              [isExternalPickup]="
                orderDetails!.isExternalPickup && orderDetails!.originAddress.type !== AddressType.Pudo
              ">
            </common-order-address>
          </div>
          <div *ngIf="contentReady && showProofOfDelivery" class="order-card fade-in">
            <common-delivery-pod
              [notes]="orderDetails!.deliveryNotes"
              [proofOfDelivery]="orderDetails!.proofOfDelivery"
              [brandColor]="elementsBackground"
              [orderStatus]="orderDetails!.customerTrackingStatus"
              [contained]="contained"
              [class.contained]="contained"
              [isExternalPickup]="orderDetails!.isExternalPickup">
            </common-delivery-pod>
          </div>
          <div @fadeInOutTrigger *ngIf="showInstagramEmbed" class="order-card fade-in" style="background: white">
            <span class="demo-display-error">{{ oEmbedDisplayError }}</span>
            <!--                        <iframe src="https://www.instagram.com/evermile.io/embed"></iframe>-->
          </div>
          <div @fadeInOutTrigger *ngIf="showContactMerchant" class="order-card fade-in">
            <common-contact-merchant
              [contained]="contained"
              [merchantEmail]="brandingInfo!.allowContactEmail ? merchantDetails!.email : undefined"
              [merchantPhone]="brandingInfo!.allowContactPhone ? merchantDetails!.phone : undefined"
              [merchantName]="
                brandingInfo!.isBranded || (orderDetails!.isGift && !isSenderTracking)
                  ? undefined
                  : merchantDetails!.name
              "
              [orderStatus]="orderDetails!.customerTrackingStatus"
              [brandColor]="elementsBackground"
              [textColor]="elementsText">
            </common-contact-merchant>
          </div>
          <div
            @fadeInOutTrigger
            *ngIf="
              brandingInfo!.isBranded &&
              promotionBranding?.enablePromotionBanner &&
              promotionBranding.promotionBanner &&
              !orderDetails!.isExternalPickup &&
              !shouldHidePromotions
            "
            class="order-card fade-in"
            id="promotion-banner"
            [class.low-opacity]="isPreview && elementForceScroll && elementForceScroll !== 'promotionBanner'">
            <common-promotion-banner
              [contained]="contained"
              [brandColor]="elementsBackground"
              [textColor]="elementsText"
              [banner]="promotionBranding!.promotionBanner!"
              [orderStatus]="orderDetails!.customerTrackingStatus">
            </common-promotion-banner>
          </div>
          <div
            @fadeInOutTrigger
            *ngIf="
              brandingInfo!.isBranded &&
              promotionBranding?.enableProductsPromotion &&
              !orderDetails!.isExternalPickup &&
              !shouldHidePromotions &&
              (contained ||
                !brandingInfo?.enableEditOrderAddProductsPromotion ||
                fabPromotionProducts?.enableOrderEdit === false)
            "
            class="order-card fade-in"
            id="products-promotion"
            #promotionProductsCard
            [class.low-opacity]="isPreview && elementForceScroll && elementForceScroll !== 'promotionProductsData'">
            <common-promotion-products
              [promotionCode]="productsPromotionDetails?.promotionCode"
              [contained]="contained"
              [brandColor]="elementsBackground"
              [textColor]="elementsText"
              [discountPercent]="productsPromotionDetails?.productsDiscount"
              [data]="promotionBranding.promotionProductsData || {}"
              [orderStatus]="orderDetails!.customerTrackingStatus"></common-promotion-products>
          </div>
          <div
            @fadeInOutTrigger
            *ngIf="brandingInfo!.isBranded && promotionBranding.instagramPromotionData && !shouldHidePromotions"
            class="order-card fade-in"
            id="instagram-promotion"
            trackable="{{ trackingPrefix || '' }}Tracking page/{{
              orderDetails!.customerTrackingStatus
            }}/Instagram promotion"
            [class.low-opacity]="isPreview && elementForceScroll && elementForceScroll !== 'instagramPromotionData'">
            <common-promotion-instagram-link [instagramPromotionData]="promotionBranding.instagramPromotionData!">
            </common-promotion-instagram-link>
          </div>
          <div
            @fadeInOutTrigger
            *ngIf="
              promotionBranding.googleReviewsUrl !== undefined &&
              (isPreview ||
                contained ||
                (orderDetails!.customerTrackingStatus === StatusEnum.Delivered && !orderDetails!.isExternalPickup))
            "
            class="order-card fade-in"
            id="google-reviews-url"
            [class.low-opacity]="isPreview && elementForceScroll && elementForceScroll !== 'googleReviewsUrl'">
            <common-google-review
              [link]="promotionBranding.googleReviewsUrl!"
              trackable="{{ trackingPrefix || '' }}Tracking page/{{
                orderDetails!.customerTrackingStatus
              }}/Google review"></common-google-review>
          </div>
          <a
            @fadeInOutTrigger
            target="_blank"
            class="order-card website fade-in"
            id="website-url"
            trackable="{{ trackingPrefix || '' }}Tracking page/{{ orderDetails!.customerTrackingStatus }}/Visit website"
            *ngIf="brandingInfo!.websiteUrl !== undefined && !shouldHidePromotions"
            [href]="brandingInfo!.websiteUrl"
            [class.disabled]="!brandingInfo!.websiteUrl">
            <div>Visit us at</div>
            <div class="link">{{ websiteUrlText ? websiteUrlText : 'Your website address' }}</div>
          </a>
          <div
            @fadeInOutTrigger
            *ngIf="contentReady && showSocialLinks && !shouldHidePromotions"
            class="social-icons fade-in"
            id="social-media-links">
            <a
              *ngFor="let socialLink of brandingInfo!.socialMediaLinks"
              [href]="socialLink.url"
              [class.disabled]="!socialLink.url"
              target="_blank"
              [ngSwitch]="socialLink.type"
              trackable="{{ trackingPrefix || '' }}Tracking Page/{{
                orderDetails!.customerTrackingStatus
              }}/Social links - {{ socialLink.type | titlecase }}">
              <common-facebook-icon *ngSwitchCase="SocialMediaType.Facebook" [color]="textColor"></common-facebook-icon>
              <common-instagram-icon
                *ngSwitchCase="SocialMediaType.Instagram"
                [color]="textColor"></common-instagram-icon>
              <common-tiktok-icon *ngSwitchCase="SocialMediaType.Tiktok" [color]="textColor"></common-tiktok-icon>
              <common-youtube-icon *ngSwitchCase="SocialMediaType.Youtube" [color]="textColor"></common-youtube-icon>
            </a>
          </div>
        </section>
      </div>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayPanelClass]="'customer-rebook-overlay-panel'"
        [cdkConnectedOverlayOpen]="showRebookOrder && !disableRebookButton"
        [cdkConnectedOverlayHasBackdrop]="true"
        (overlayKeydown)="overlayRebookKeyDown($event)"
        (backdropClick)="toggleRebookFullScreen(false)">
        <common-failed-delivery-rebook-flow
          #failedDeliveryRebookFlow
          (closeEvent)="showRebookOrder = false"
          (timeSlotConfirmed)="onSelectRebookOption($event)"></common-failed-delivery-rebook-flow>
      </ng-template>
    </main>
    <div class="shadow-blocker shadow-blocker--footer" [class.ready]="contentReady" *ngIf="!embedded"></div>
  </ng-container>
  <ng-container *ngIf="loadingState || errorState || !contentReady">
    <div class="loading-state">
      <img *ngIf="loadingState" src="assets/loading-circle-white-animated.svg" />
      <div *ngIf="errorState" class="unavailable">
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.66667 3.6665L40.3333 40.3332"
            stroke="white"
            stroke-width="5"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M15.4 4.94984C17.6 4.2165 19.8 3.6665 22.1833 3.6665C32.2667 3.6665 40.5167 11.9165 40.5167 21.9998C40.5167 24.3832 40.15 26.5832 39.2333 28.5998"
            stroke="white"
            stroke-width="5"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M35.0167 35.0165C31.7167 38.3165 27.1333 40.3332 22 40.3332C11.9167 40.3332 3.66667 32.0832 3.66667 21.9998C3.66667 17.0498 5.86667 12.4665 9.16667 9.1665"
            stroke="white"
            stroke-width="5"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
        <div class="unavailable-text">This page is no <br />longer available</div>
      </div>
    </div>
  </ng-container>
  <common-fab-promotion-products
    #fabPromotionProducts
    (promotionFabDisplayChange)="promotionFabDisplayChange.emit($event)"
    *ngIf="
      orderDetails &&
      brandingInfo?.isBranded &&
      promotionBranding?.enableProductsPromotion &&
      productsPromotionDetails &&
      !orderDetails.isExternalPickup &&
      !shouldHidePromotions &&
      (orderDetails.customerTrackingStatus === StatusEnum.Ordered ||
        orderDetails.customerTrackingStatus === StatusEnum.OnItsWay ||
        orderDetails.customerTrackingStatus === StatusEnum.Delivered)
    "
    [brandColor]="background"
    [className]="'products-fab-container'"
    [elementsBackgroundColor]="elementsBackground"
    [promotionProductsScrollState]="promotionProductsScrollState"
    (scrollToProductsCard)="scrollToProductsCard()"
    [textColor]="elementsText"
    [allowOrderEdit]="
      brandingInfo!.enableEditOrderAddProductsPromotion && orderDetails!.customerTrackingStatus === StatusEnum.Ordered
    "
    [promotionDetails]="productsPromotionDetails!"
    [promotionProductsData]="promotionBranding.promotionProductsData || {}"
    [orderStatus]="orderDetails!.customerTrackingStatus">
  </common-fab-promotion-products>
  <footer [class.loading]="loadingState || errorState || !contentReady" [class.ready]="contentReady" *ngIf="!embedded">
    <a
      href="https://www.evermile.ai"
      target="_blank"
      trackable="{{ trackingPrefix || '' }}Tracking Page/{{
        orderDetails?.customerTrackingStatus ? orderDetails?.customerTrackingStatus : 'Loading'
      }}/Footer evermile logo">
      Powered by
      <common-evermile-logo [width]="51.5" [height]="10" [color]="textColor" />
    </a>
  </footer>
</div>
